module.exports = __webpack_public_path__ + "img/c08ec8fbdeaee54b73f1922cec37b1e7.png";